module.exports = __webpack_public_path__ + "static/media/step-1.7324446b.png";